import { render, staticRenderFns } from "./AssetLocationEditor.vue?vue&type=template&id=72c8d068&"
import script from "./AssetLocationEditor.vue?vue&type=script&lang=js&"
export * from "./AssetLocationEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports